'use client';
import Icon from '../Icon';
import { programs, activity, recommendPrograms } from '@/lib/vster/data';

interface Props { navigate: (s: string) => void; }

export default function DashboardScreen({ navigate }: Props) {
  const recommend = programs.slice(0, 3).map((p, i) => ({
    ...p,
    reason: [['업종 일치', '업력 조건 충족'], ['업종 일치', '지역 일치'], ['관심분야 일치']][i],
  }));

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', gap: 16, flexWrap: 'wrap', marginBottom: 28 }}>
        <div>
          <h1 className="vh1" style={{ fontSize: 32, fontWeight: 700, letterSpacing: '-.015em', margin: '0 0 4px' }}>반갑습니다, 정원테크님 👋</h1>
          <p style={{ fontSize: 16, color: '#434654', margin: 0 }}>기업 맞춤 지원사업과 진행 현황 요약입니다.</p>
        </div>
      </div>

      {/* 통계 카드 */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(220px,1fr))', gap: 18, marginBottom: 36 }}>
        {[
          { icon: 'bookmark', iconBg: '#e9edff', iconColor: '#003d9b', badge: '이번 주 +2', badgeBg: '#f1f3ff', badgeColor: '#434654', badgeIcon: 'trending_up', badgeIconColor: '#1f8a5b', label: '관심 사업', value: '12', border: '1px solid #e4e8f6' },
          { icon: 'send', iconBg: '#d6f0e2', iconColor: '#10663f', badge: '1건 선정', badgeBg: '#d6f0e2', badgeColor: '#10663f', badgeIcon: 'check_circle', label: '트래킹', value: '4', border: '1px solid #e4e8f6' },
          { icon: 'event', iconBg: '#ffdad6', iconColor: '#93000a', badge: '조치 필요', badgeBg: '#ffdad6', badgeColor: '#93000a', badgeIcon: 'warning', label: '마감 임박 (D-3 이내)', value: '2', valueColor: '#ba1a1a', border: '1.5px solid #ffdad6' },
        ].map((s, i) => (
          <div key={i} style={{ background: '#fff', border: s.border, borderRadius: 16, padding: 20, display: 'flex', flexDirection: 'column', gap: 18, boxShadow: '0 4px 18px rgba(5,26,62,.04)' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ width: 42, height: 42, borderRadius: 11, background: s.iconBg, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Icon name={s.icon} size={24} color={s.iconColor} fill={1} />
              </span>
              <span style={{ fontFamily: "'JetBrains Mono',monospace", fontSize: 12, background: s.badgeBg, color: s.badgeColor, padding: '4px 8px', borderRadius: 7, display: 'flex', alignItems: 'center', gap: 4 }}>
                <Icon name={s.badgeIcon} size={14} color={s.badgeIconColor || s.badgeColor} />{s.badge}
              </span>
            </div>
            <div>
              <div style={{ fontSize: 15, color: '#434654', marginBottom: 2 }}>{s.label}</div>
              <div style={{ fontSize: 40, fontWeight: 700, lineHeight: 1, color: s.valueColor }}>{s.value}</div>
            </div>
          </div>
        ))}
      </div>

      {/* 맞춤 추천 */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h2 style={{ fontSize: 22, fontWeight: 700, margin: 0, display: 'flex', alignItems: 'center', gap: 8 }}>
          <Icon name="auto_awesome" size={24} color="#00687b" fill={1} />맞춤 추천
        </h2>
        <button onClick={() => navigate('recommend')} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#003d9b', fontSize: 14, fontWeight: 600 }}>모든 추천 보기</button>
      </div>
      <div className="vrow" style={{ display: 'flex', gap: 16, overflowX: 'auto', paddingBottom: 14, marginBottom: 36 }}>
        {recommend.map((p, i) => (
          <div key={i} onClick={() => navigate('detail')} style={{ flexShrink: 0, width: 320, background: '#fff', border: '1px solid #e4e8f6', borderRadius: 16, padding: 18, display: 'flex', flexDirection: 'column', gap: 11, cursor: 'pointer', boxShadow: '0 4px 18px rgba(5,26,62,.04)' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ fontFamily: "'JetBrains Mono',monospace", fontSize: 12, fontWeight: 600, color: '#005f71', background: '#50dcff', padding: '4px 11px', borderRadius: 999 }}>{p.match} 일치</span>
              <span style={{ fontFamily: "'JetBrains Mono',monospace", fontSize: 12, fontWeight: 600, padding: '3px 9px', borderRadius: 6, background: p.ddBg, color: p.ddColor }}>{p.dday}</span>
            </div>
            <h3 style={{ fontSize: 18, fontWeight: 600, lineHeight: 1.3, margin: '2px 0 0' }}>{p.title}</h3>
            <span style={{ fontFamily: "'JetBrains Mono',monospace", fontSize: 12, color: '#737685' }}>{p.org}</span>
            <p style={{ fontSize: 14, lineHeight: 1.5, color: '#434654', margin: 0, display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>{p.summary}</p>
            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
              {p.reason.map((r: string) => (
                <span key={r} style={{ fontFamily: "'JetBrains Mono',monospace", fontSize: 11, background: '#f1f3ff', color: '#10663f', padding: '3px 8px', borderRadius: 6, display: 'flex', alignItems: 'center', gap: 3 }}>
                  <Icon name="check" size={13} />
                  {r}
                </span>
              ))}
            </div>
            <span style={{ fontSize: 16, fontWeight: 700, color: '#003d9b', borderTop: '1px solid #eef1fb', paddingTop: 11, marginTop: 2 }}>{p.amount}</span>
          </div>
        ))}
      </div>

      {/* 최근 활동 + 프로필 */}
      <div className="vstack-sm" style={{ display: 'grid', gridTemplateColumns: 'minmax(0,2fr) minmax(280px,1fr)', gap: 24, alignItems: 'start' }}>
        <div>
          <h2 style={{ fontSize: 22, fontWeight: 700, margin: '0 0 16px' }}>최근 활동</h2>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {activity.map((a, i) => (
              <div key={i} style={{ background: '#fff', border: '1px solid #e4e8f6', borderRadius: 14, padding: 18, display: 'flex', gap: 14, boxShadow: '0 2px 12px rgba(5,26,62,.03)' }}>
                <span style={{ width: 10, height: 10, borderRadius: '50%', background: a.dot, marginTop: 6, flexShrink: 0, display: 'inline-block' }} />
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8, marginBottom: 6 }}>
                    <span style={{ fontFamily: "'JetBrains Mono',monospace", fontSize: 12, fontWeight: 600, padding: '3px 9px', borderRadius: 6, background: a.tagBg, color: a.tagColor }}>{a.tag}</span>
                    <span style={{ fontFamily: "'JetBrains Mono',monospace", fontSize: 12, color: '#737685' }}>{a.time}</span>
                  </div>
                  <h4 style={{ fontSize: 16, fontWeight: 600, margin: '0 0 4px' }}>{a.title}</h4>
                  <p style={{ fontSize: 14, lineHeight: 1.55, color: '#434654', margin: 0 }}>{a.desc}</p>
                  {a.action && <button style={{ marginTop: 10, background: '#fff', border: '1.5px solid #003d9b', color: '#003d9b', cursor: 'pointer', padding: '7px 14px', borderRadius: 9, fontSize: 13, fontWeight: 600 }}>{a.action}</button>}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          {/* 프로필 완성도 */}
          <div style={{ background: '#fff', border: '1px solid #e4e8f6', borderRadius: 16, padding: 20 }}>
            <h3 style={{ fontSize: 16, fontWeight: 700, margin: '0 0 14px', borderBottom: '1px solid #eef1fb', paddingBottom: 12 }}>프로필 완성도</h3>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
              <span style={{ fontSize: 14, color: '#434654' }}>매칭 정확도</span>
              <span style={{ fontSize: 15, fontWeight: 700, color: '#003d9b' }}>82%</span>
            </div>
            <div style={{ height: 9, borderRadius: 999, background: '#e9edff', overflow: 'hidden' }}>
              <div style={{ width: '82%', height: '100%', background: 'linear-gradient(90deg,#003d9b,#00687b)' }} />
            </div>
            <p style={{ fontSize: 13, color: '#737685', margin: '12px 0 0', lineHeight: 1.5 }}>보유 인증 정보를 추가하면 매칭 정확도가 최대 12%p 올라갑니다.</p>
            <button onClick={() => navigate('onboarding')} style={{ marginTop: 12, width: '100%', background: '#e9edff', color: '#003d9b', border: 'none', cursor: 'pointer', padding: 10, borderRadius: 9, fontSize: 14, fontWeight: 600 }}>프로필 업데이트</button>
          </div>
          {/* 인사이트 */}
          <div style={{ background: '#003d9b', borderRadius: 16, padding: 20, color: '#fff', position: 'relative', overflow: 'hidden' }}>
            <span style={{ position: 'absolute', right: -10, bottom: -14, fontFamily: "'Material Symbols Outlined'", fontSize: 96, color: 'rgba(255,255,255,.12)' }}>lightbulb</span>
            <h3 style={{ fontSize: 16, fontWeight: 700, margin: '0 0 8px', position: 'relative' }}>이번 주 인사이트</h3>
            <p style={{ fontSize: 14, lineHeight: 1.55, margin: 0, color: '#dae2ff', position: 'relative' }}>R&D 과제 2건의 마감이 이번 주에 몰려 있습니다. 플래너에서 제출 일정을 먼저 확정하세요.</p>
            <button onClick={() => navigate('planner')} style={{ marginTop: 12, background: '#fff', color: '#003d9b', border: 'none', cursor: 'pointer', padding: '9px 16px', borderRadius: 9, fontSize: 13, fontWeight: 600, position: 'relative' }}>플래너 열기</button>
          </div>
        </div>
      </div>
    </div>
  );
}
